module.exports = __webpack_public_path__ + "img/cjcl7.c1b02dfc.png";